import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertComponent } from './alert.component';
import { AlertFooterDirective, AlertIconDirective } from './alert-sections';
import { AlertIconComponent } from './alert-icon.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [
    AlertComponent,
    AlertIconDirective,
    AlertFooterDirective,
    AlertIconComponent,
  ],
  exports: [
    AlertComponent,
    AlertIconDirective,
    AlertFooterDirective,
    AlertIconComponent,
  ],
})
export class AlertModule {}
